module.exports = __webpack_public_path__ + "img/chatbot.2ffb04b0.png";